module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('ul', {
    staticClass: "client-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/community-projects"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Our-Work-Page/portfoliohome01.png",
      "alt": "COMMUNITY PROJECTS"
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/k12-schools"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Our-Work-Page/portfoliohome02.png",
      "alt": "K-12 SCHOOLS"
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/parks"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Our-Work-Page/portfoliohome03.png",
      "alt": "PARKS"
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/churches"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Our-Work-Page/portfoliohome04.png",
      "alt": "CHURCHES"
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/military"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Our-Work-Page/portfoliohome05.png",
      "alt": "MILITARY"
    }
  })])], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/client-list"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Our-Work-Page/portfoliohome08.png",
      "alt": "CLIENT LIST"
    }
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portfolio-map"
  }, [_c('div', {
    staticClass: "portfolio-map-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "221",
      "height": "141",
      "src": "images/Our-Work-Page/map.png",
      "alt": "USA map"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "portfolio-map-right"
  }, [_c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("\n                FROM COMMUNITY PROJECTS\n                "), _c('br', {
    staticClass: "break-sm"
  }), _vm._v("\n                TO MAJOR SPORTS TEAMS,\n                "), _c('br'), _vm._v("\n                WE HAVE A PROJECT IN YOUR AREA!\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "portfolio-map-numbers"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "493",
      "height": "28",
      "src": "images/Our-Work-Page/mapnumbers.png",
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portfolio-map-numbers-sm"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "493",
      "height": "28",
      "src": "images/Our-Work-Page/mapnumbers.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://fundraiserssports.com/projects-sports.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Our-Work-Page/portfoliohome06.png",
      "alt": "PROFESSIONAL SPORTS"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://fundraiserssports.com/projects-university.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Our-Work-Page/portfoliohome07.png",
      "alt": "UNIVERSITIES/COLLEGES"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01d9752c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurWork.vue
// module id = lyNd
// module chunks = 1